import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=f885343c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=f885343c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f885343c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f885343c')) {
      api.createRecord('f885343c', component.options)
    } else {
      api.reload('f885343c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=f885343c&scoped=true&", function () {
      api.rerender('f885343c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YYq8VFPz1Yck/JS/comp/PopupDialog.vue"
export default component.exports